import type { CheckboxGroupFieldDefinition, RadioGroupFieldDefinition } from "../../types.ts";
import { appendGroupHelpText, createGroupFieldset, toDomId } from "../shared.ts";
import type { RenderContext } from "../types.ts";

/** The non-SELECT choice fields rendered as native option groups. */
export type GroupFieldDefinition = CheckboxGroupFieldDefinition | RadioGroupFieldDefinition;

/**
 * Renders a `CHECKBOX_GROUP` or `RADIO_GROUP` fieldset.
 *
 * `required` is applied natively only to the first radio of a required radio
 * group; checkbox-group validity is enforced separately via custom validity.
 */
export const renderChoiceGroup = (
  field: GroupFieldDefinition,
  context: RenderContext,
): HTMLFieldSetElement => {
  const group = createGroupFieldset(field);
  const isRadioGroup = field.type === "RADIO_GROUP";

  field.configJson.options.forEach((option, index) => {
    const label = document.createElement("label");
    label.className = "fb-choice";

    const input = document.createElement("input");
    input.id = `${context.instanceId}-${toDomId(field.id)}-${toDomId(option.id)}`;
    input.name = field.key;
    input.type = isRadioGroup ? "radio" : "checkbox";
    input.value = option.value;
    input.required = isRadioGroup && field.required && index === 0;

    label.append(input, document.createTextNode(option.label));
    group.append(label);
  });

  appendGroupHelpText(group, field, context);

  return group;
};
